<app-header>

</app-header>

<app-sidebar></app-sidebar>

<app-right-sidebar></app-right-sidebar>
<app-breadcrumbs></app-breadcrumbs>
<div class="col-12" style="background-color: #fff;">
    <router-outlet>
        <ngx-ui-loader>


        </ngx-ui-loader>


    </router-outlet>
</div>